import { getTheme } from '@conexasaude/conexa-hero'

const theme = getTheme()

export const captionColors = {
  medium: theme.colors.neutral[300],
  large: theme.colors.neutral[500],
}
